import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import ProteinAlignmentPage from './pages/ProteinAlignmentPage';
import AntigenicPeptidePage from './pages/AntigenicPeptidePage';
import VaccineDesignerPage from './pages/VaccineDesignerPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/service/protein-alignment" element={<ProteinAlignmentPage />} />
          <Route path="/service/antigenic-peptide" element={<AntigenicPeptidePage />} />
          <Route path="/service/vaccine-designer" element={<VaccineDesignerPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
